import { useEffect, useState } from 'react';
import { useFetch } from '../useFetch';
import { BASE_URL_MAP } from '../../lib/environment';

interface ApiBranch {
  ID: string;
  Name: string;
  MediaroomIp: string;
}

export const useBranch = () => {
  const [branches, setBranches] = useState<OperatorBranch[]>([]);
  const { loading, makeRequest, response } = useFetch();

  useEffect(() => {
    getBranches();
  }, []);

  useEffect(() => {
    if (response && !loading) {
      setBranches(response.map((branch: ApiBranch) => mapBranch(branch)));
    }
    // eslint-disable-next-line
  }, [loading, response]);

  const getBranches = () =>
    makeRequest(`${BASE_URL_MAP['Residential']}/Branch/AllBranches`, 'get');

  return {
    branches,
    loading,
  };
};

const mapBranch = (branch: ApiBranch): OperatorBranch => ({
  id: branch.ID,
  name: branch.Name,
  mediaroomIp: branch.MediaroomIp,
});
